"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _OverviewRow = _interopRequireDefault(require("../OverviewRow"));
var LockIcon = function LockIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 4a2.97 2.97 0 0 1 2.118.886A3.038 3.038 0 0 1 15 7.035v2.964H9V7.035a3.065 3.065 0 0 1 .882-2.15A2.997 2.997 0 0 1 12 4zm5 6V7.034a5.067 5.067 0 0 0-1.461-3.557A4.997 4.997 0 0 0 12 2a4.97 4.97 0 0 0-3.539 1.478A5.037 5.037 0 0 0 7 7.035v2.964H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1zm1 2v8H6v-8h12zm-6 2a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0v-2a1 1 0 0 1 1-1z"
  }));
};
LockIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var WorldIcon = function WorldIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.781 4.687c-.09.189-.175.384-.256.585C7.908 6.812 7.512 8.811 7.42 11H4.074a7.926 7.926 0 0 1 .777-2.568 8.02 8.02 0 0 1 3.93-3.745zM12 2.012a9.988 9.988 0 1 0 0 19.976 9.988 9.988 0 1 0 0-19.976zm0 2c.134 0 .362.063.675.394.315.332.644.867.942 1.61.51 1.271.868 3.008.96 4.984H9.422c.091-1.976.45-3.713.96-4.984.298-.743.627-1.278.942-1.61.313-.33.542-.394.676-.394zM16.579 11c-.093-2.189-.488-4.188-1.105-5.727a9.792 9.792 0 0 0-.256-.587 8.02 8.02 0 0 1 3.93 3.746c.396.79.664 1.654.778 2.568h-3.347zm-2.002 2c-.092 1.975-.45 3.713-.96 4.983-.298.744-.627 1.278-.942 1.61-.313.33-.541.395-.675.395-.135 0-.363-.064-.676-.394-.315-.333-.645-.867-.942-1.61-.51-1.272-.869-3.009-.96-4.984h5.155zm.64 6.313c.091-.19.176-.385.257-.586.617-1.54 1.012-3.539 1.105-5.727h3.347a7.924 7.924 0 0 1-.777 2.568 8.019 8.019 0 0 1-3.931 3.745zm-6.436 0a8.02 8.02 0 0 1-3.93-3.745A7.926 7.926 0 0 1 4.074 13H7.42c.092 2.188.488 4.187 1.105 5.727.08.201.166.397.256.586z"
  }));
};
WorldIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "icon": "icon_m8hwKl"
}; 
require('./OverviewVisibility.css');
var OverviewVisibility = function OverviewVisibility(_ref) {
  var asset = _ref.asset,
    config = _ref.config,
    versionsNavigation = _ref.versionsNavigation;
  var visibilityInfo = asset.isPublic ? {
    Icon: WorldIcon,
    label: 'Public'
  } : {
    Icon: LockIcon,
    label: 'Private'
  };
  return versionsNavigation === 'version-group' && config.mulesoft.id !== asset.organization.id ? /*#__PURE__*/_react.default.createElement(_OverviewRow.default, {
    title: "Visibility",
    testId: "asset-visibility"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon,
    size: "s",
    isDecorative: true
  }, /*#__PURE__*/_react.default.createElement(visibilityInfo.Icon, null)), /*#__PURE__*/_react.default.createElement("span", {
    title: visibilityInfo.label
  }, visibilityInfo.label)) : null;
};
var _default = exports.default = OverviewVisibility;
//# sourceMappingURL=OverviewVisibility.js.map